.fieldset {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.options {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.options[data-orientation="horizontal"] {
  flex-flow: row wrap;
  gap: var(--space-4);
}

.item {
  display: flex;
}

.optionLabel {
  display: inline-flex;
  gap: var(--space-2);
  align-items: flex-start;
  min-block-size: var(--control-sm);
  padding-block: var(--space-1);
  color: var(--color-text);
  font-size: var(--text-md);
  line-height: var(--leading-tight);
  cursor: default;
}

.optionLabel[data-disabled] {
  color: var(--color-text-subtle);
}

.optionText {
  display: flex;
  flex-direction: column;
  gap: calc(var(--space-1) / 2);
}

.optionDescription {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
  line-height: var(--leading-normal);
}

.radio {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  inline-size: var(--icon-sm);
  block-size: var(--icon-sm);
  border: var(--border-width) solid var(--color-border-strong);
  border-radius: var(--radius-full);
  background: var(--color-surface);
}

.radio[data-checked] {
  border-color: var(--color-accent);
}

.radio[data-disabled] {
  border-color: var(--color-border);
  background: var(--color-surface-sunken);
}

.radio:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.indicator {
  inline-size: calc(var(--icon-sm) / 2);
  block-size: calc(var(--icon-sm) / 2);
  border-radius: var(--radius-full);
  background: var(--color-accent);
}

.indicator[data-unchecked] {
  display: none;
}
